import { make } from 'vuex-pathify';
import { filter, keys, keyBy, shuffle, sortBy, values } from 'lodash';

const quiz = keyBy(
    [
        {
            id: 1,
            question:
                'People say a lot of bad stuff about trans folks without recognizing everything that’s good about us. If you only listened to the negative stuff, you’d think we’re all homeless, we’re all sex workers, and we don’t have hopes or dreams. Defining ourselves by what other people say is dangerous because, when we start to believe it, we forget we’re worth protecting and then do things that can cause HIV or STIs.',
            name: 'Stereotypes',
            color: 'info',
            correct: false
        },
        {
            id: 2,
            question:
                'Sometimes trans folks are more likely to engage in condomless sex or needle sharing because they’ve had to overcome many challenges presented by others in their life. Maybe they’ve been discriminated against by others at work, school, or at home. As a result, they’re without health care, a stable home, or an income. Like a border or a wall, these kinds of situations can hold someone back from staying protected from HIV and STIs.',
            name: 'Barriers',
            color: 'success',
            correct: false
        },
        {
            id: 3,
            question:
                'There’s a lot of false information out there, and sometimes we take risks because we don’t know the Real T! For example, have you heard of pumping? It’s when we have someone inject silicone into our faces, breasts, hips, or butts to give us a more feminine or curvy appearance. It’s not done by a doctor, and it can be dangerous. We’ll talk more about it later on.',
            name: 'Knowledge',
            color: 'warning',
            correct: false
        },
        {
            id: 4,
            question:
                'We take risks for all sorts of reasons. We might not feel comfortable talking to our partners about using condoms so we don’t use them, or we might not have clean needles, so we share, or we might use drugs and alcohol to cope.',
            name: 'Risky Behavior',
            color: 'error',
            correct: false
        }
    ],
    'id'
);
const quizOrder = sortBy(keys(quiz), k => parseInt(k));

const facts = keyBy(
    [
        {
            id: 1,
            title: 'Trans Pride',
            color: 'info',
            text:
                'Learn about members of the trans community and create your own Icon Promo. Wait! You already did this! Congratulations, you’re ¼ of the way through the activities!',
            visited: false
        },
        {
            id: 2,
            title: 'Breaking Down Barriers',
            color: 'success',
            text:
                'We will learn about communication and respect to help build skills to deal with discrimination and harassment in lots of different settings. In the resource guide, you can find list of resources for trans-friendly medical care.',
            visited: false
        },
        {
            id: 3,
            title: 'Educating Yourself',
            color: 'warning',
            text:
                'We’ll talk about knowledge to provide you with the correct information to counter the misinformation out there!  We’re going to give you the real T on HIV and other sexually transmitted infections (STIs). We’ll also give you information on hormone use, pumping, and other types of health protection.',
            visited: false
        },
        {
            id: 4,
            title: 'Protecting Yourself',
            color: 'error',
            text:
                'We’re going to help you build skills to protect yourself in different situations with sexual partners. We’ll also talk about what happens when drugs and alcohol are in the mix. 💊🌿🚬',
            visited: false
        }
    ],
    'id'
);
const factsOrder = sortBy(keys(facts), k => parseInt(k));

const state = {
    title: 'Why LifeSkills?',
    complete: false,
    sticker: {
        text: 'Gold Star',
        earned: false,
        image: require('@/assets/stickers/stickers_0002_star.png')
    },
    bonusSticker: false,
    trophy: false,
    quiz,
    quizOrder,
    facts,
    factsOrder
};
const getters = {
    ...make.getters(state),
    currentQuizItem: state => {
        const remaining = shuffle(filter(values(state.quiz), { correct: false })); // shuffle the remaining unanswered questions
        if (remaining && remaining.length) {
            return state.quiz[remaining[0].id]; // pick from the top of the shuffled remaining pile
        }
        return null;
    },
    allFactsVisited: state => {
        return 0 === filter(values(state.facts), { visited: false }).length;
    }
};
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
